import ManuallyAddAssetForm from './ManuallyAddAssetForm';

export default ManuallyAddAssetForm;
